export const UDPConfigFieldMapping = {
  //setup
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIAN: 'technician',
  TECHINICIANID: 'technicianId',
  COMMENTS: 'comments',
  ENGINE_A_INFO: 'engine-a-info',
  ENGINE_B_INFO: 'engine-b-info',
  SHA_ID: 'shaId',
  TEST_MODE: 'testMode',
  DIRECTION: 'direction',
  TEST_DURATION: 'TestDuration',
  TEST_CUSTOM_DURATION: 'customDuration',
  STREAM_RATE_CONVENTION: 'unit-convention',
  VLAN: 'vlan',
  EXPIRATION_DEFAULT_VALUE: 'expiration-default-value',
  EXPIRATION_DATE: 'expiration-date',
  MAX_EXECUTION_COUNTS: 'max-execution-counts',
  TEST_TYPE: 'testType',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',
  SCHEDULER: 'scheduler',

  //streams
  STREAMS_A2B: 'streamsInfoA2B',
  STREAMS_B2A: 'streamsInfoB2A',
  STREAM_NUMBER: 'stream-number',
  STREAM_NAME: 'name',
  STREAM_TYPE: 'stream-type',
  STREAM_L2_IR_A2B: 'l2-ir-a2b',
  STREAM_L2_IR_B2A: 'l2-ir-b2a',
  UDP_BW_A2B: 'udp-bw-a2b',
  UDP_BW_B2A: 'udp-bw-b2a',
  FRAME_SIZE: 'frame-size',
  POCKET_LOSS_RATIO: 'pocket-loss-ratio',
  JITTER_THRESHOLD: 'jitter-threshold',
  UDP_PORT: 'udp-port',
  CODEC: 'codec',
  SAMPLING_RATE: 'samplingRate',
  CALLS: 'calls',
  VIDEO_TYPE: 'videoType',
  COMPRESSION: 'compression',
  CHANNELS: 'channels',
  MAX_SERVICES: 'maxServices',
  MAX_BANDWIDTH: 'max_bandwidth',
  VALID_FRAME_SIZES: 'validFrameSizes',
  STREAM_IN_USE: 'stream-in-use'
};
export const A2B_TABLE_COLUMNS = [
  'streamName',
  'streamType',
  'streamL2IrA2B',
  'streamUdpBwA2B',
  'streamFrameSize',
  'streamPacketLossRatio',
  'streamJitterThreshold',
  'streamUdpPort',
  'streamAction'
];
export const B2A_TABLE_COLUMNS = [
  'streamName',
  'streamType',
  'streamL2IrB2A',
  'streamUdpBwB2A',
  'streamFrameSize',
  'streamPacketLossRatio',
  'streamJitterThreshold',
  'streamUdpPort',
  'streamAction'
];
export const TEST_DURATIONS = [
  { name: '1 minute', value: 60 },
  { name: '15 minutes', value: 900 },
  { name: '2 Hours', value: 7200 },
  { name: '24 Hours', value: 86400 },
  { name: 'User Defined', value: 'custom' }
];

export const VLAN_TYPE_SELECTION = [
  { name: 'Untagged', value: 46 },
  { name: 'Single VLAN', value: 50 },
  { name: 'Q-in-Q', value: 54 }
];

export enum streamRateConventionLabel {
  L1 = 'L1 Mbps (ULR)',
  L2 = 'L2 Mbps (IR)'
}

export enum streamRateConventionValue {
  L1 = 'l1-mbps',
  L2 = 'l2-mbps'
}

export const STREAM_RATE_TYPE = [
  { name: streamRateConventionLabel.L2, value: streamRateConventionValue.L2 },
  { name: streamRateConventionLabel.L1, value: streamRateConventionValue.L1 }
];

export const STREAM_TYPE_SELECTION = [
  { name: 'Data', value: 'Data' },
  { name: 'Video', value: 'Video' },
  { name: 'Voice', value: 'Voice' }
];

export const VIDEO_TYPE_SELECTION = [
  { name: 'HDTV', value: 'HDTV' },
  { name: 'SDTV', value: 'SDTV' }
];

export const COMPRESSION_TYPE_SELECTION = [
  { name: 'MPEG-2', value: 'MPEG2' },
  { name: 'MPEG-4', value: 'MPEG4' }
];

export const SAMPLING_RATE_SELECTION = [
  { name: '10', value: 10 },
  { name: '20', value: 20 },
  { name: '30', value: 30 },
  { name: '40', value: 40 },
  { name: '50', value: 50 },
  { name: '60', value: 60 },
  { name: '70', value: 70 },
  { name: '80', value: 80 },
  { name: '90', value: 90 },
  { name: '100', value: 100 },
  { name: '110', value: 110 },
  { name: '120', value: 120 }
];

export const VIDEO_CHANNEL_RANGES = {
  SDTV: {
    MPEG2: {
      numChannels: { min: 1, max: 250 }
    },
    MPEG4: {
      numChannels: { min: 1, max: 500 }
    }
  },
  HDTV: {
    MPEG2: {
      numChannels: { min: 1, max: 52 }
    },
    MPEG4: {
      numChannels: { min: 1, max: 142 }
    }
  }
};

export const CODEC_SELECTION = [
  {
    id: 'G.711',
    value: 'G711',
    payload: 80,
    numCalls: { min: 1, max: 7911 }
  },
  {
    id: 'G.723 5.3K',
    value: 'G72353K',
    payload: 7,
    numCalls: { min: 1, max: 14705 }
  },
  {
    id: 'G.723 6.3K',
    value: 'G72363K',
    payload: 8,
    numCalls: { min: 1, max: 14534 }
  },
  {
    id: 'G.729',
    value: 'G729',
    payload: 10,
    numCalls: { min: 1, max: 14204 }
  },
  {
    id: 'G.726 32K',
    value: 'G72632K',
    payload: 40,
    numCalls: { min: 1, max: 10593 }
  },
  {
    id: 'G.722 64K',
    value: 'G72264K',
    payload: 80,
    numCalls: { min: 1, max: 7911 }
  },
  {
    id: 'GSM FR',
    value: 'GSM_FR',
    payload: 14,
    numCalls: { min: 1, max: 7911 }
  },
  {
    id: 'GSM EFR',
    value: 'GSM_EFR',
    payload: 15,
    numCalls: { min: 1, max: 7911 }
  }
];

export const UDP_PORT_LIST = [8080, 8081, 8082, 8083, 8084, 8085, 8086, 8087, 8088, 8089];
export const STREAM_NUMBERS_A2B = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const STREAM_NUMBERS_B2A = [11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

export const DEFAULT_STREAM_A2B = [
  {
    'stream-number': 1,
    name: 'service 1',
    'stream-type': 'Data',
    'l2-ir-a2b': '10.00',
    'udp-bw-a2b': '9.10',
    'frame-size': '512',
    'pocket-loss-ratio': '0',
    'jitter-threshold': '0',
    'udp-port': 8080,
    'stream-in-use': true
  }
];
export const DEFAULT_STREAM_B2A = [
  {
    'stream-number': 11,
    name: 'service 11',
    'stream-type': 'Data',
    'l2-ir-b2a': '10.00',
    'udp-bw-b2a': '9.10',
    'frame-size': '512',
    'pocket-loss-ratio': '0',
    'jitter-threshold': '0',
    'udp-port': 8080,
    'stream-in-use': true
  }
];
